import {Component} from '@angular/core';
import {NgbActiveModal} from "@ng-bootstrap/ng-bootstrap";
import {BaseModalComponent} from "../../../views/modal/base_modal.component";
import {FilterParams} from "../../../models/filter_form.model";

@Component({
	template: `<base-modal
		[title]="title"
		[isLoading]="isLoading"
		[btnOkClass]="btnOkClass"
		[btnOkLabel]="btnOkLabel"
		(onOk)="ok()"
	>
			

		<div class="container">
			<div class="row">
				<div class="col">
					<ng-content></ng-content>
				</div>
			</div>

			<div class="row">
				<div class="col">
					<pre innerHTML="{{ sql }}"></pre>
				</div>
			</div>
			
			<div class="row">
				<div class="col">
					<table class="table">
						<thead>
						<tr>
							<th>параметр</th>
							<th>изменение</th>
						</tr>
						</thead>

						<tbody>
						<tr *ngFor="let param of filterParams">
							<td>
								{{ 'adminstat.filterForm.' + param.key | translate }}
							</td>

							<td>
								{{ param.value }}
							</td>
						</tr>
						</tbody>
					</table>
				</div>
			</div>
		</div>
	</base-modal>`
})
export class FilterComponent extends BaseModalComponent {
	filterParams: FilterParams;
	sql = '';
	
	constructor(
		activeModal: NgbActiveModal,
	) {
		super(activeModal);
	}

	ok() {
		this.close();
	}
}
